import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { FormattedMessage } from '../../util/reactIntl';
import config from '../../config';
import {
  getFeeData,
  getFeeFormatted,
  getTotalPriceFormatted,
  getAdditionalFeeFormatted
} from '../../util/offerPricing';
import { IconArrowHead, InfoTipForFields } from '../../components';
import UploadedFiles from './UploadedFiles';
import css from './BookingPanel.module.css';

const { Money } = sdkTypes;

const priceData = (price, intl) => {
  if (price && price.currency === config.currency) {
    const formattedPrice = formatMoney(intl, price);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: `(${price.currency})`,
      priceTitle: `Unsupported currency (${price.currency})`,
    };
  }
  return {};
};

const AccordionOffers = props => {
  const { currentTransaction, currentUser, isProvider, intl } = props;

  const offersData = currentTransaction?.attributes?.protectedData?.offersData;
  if (!offersData?.length) return null

  const offerFeeData = getFeeData(currentUser, currentTransaction, isProvider);

  const feeFormatted = getFeeFormatted(offerFeeData, currentTransaction, intl);
  const additionalFeeFormatted = getAdditionalFeeFormatted(currentTransaction, intl, isProvider);
  const totalPriceFormatted = getTotalPriceFormatted(offerFeeData, currentUser, currentTransaction, intl, isProvider);

  const [activeItem, setActiveItem] = useState(0);

  return (
    <>
      <div className={css.offersWrapper}>


        <div className={css.offerAccordion}>
          {offersData.map((o, i, arr) => {

            const currentOfferPrice = o.price;
            const currentOfferCurrency = o.currency;
            const { formattedPrice } = priceData(currentOfferPrice, intl);

            return (
              <div className={classNames(css.offerItemAccordion, { [css.offerItemAccordionActive]: activeItem === i })}>

                <h2
                  className={css.offerTitle}
                  onClick={() => activeItem === i ? setActiveItem(-1) : setActiveItem(i)}
                >
                  Offer {arr?.length - i}
                  {offersData?.length > 1 && (
                    <IconArrowHead direction={activeItem === i ? 'up' : 'down'} />
                  )}
                </h2>

                {activeItem === i && (
                  <div className={css.offerInfo}>
                    <div className={css.offerPrice}>
                      {currentOfferPrice?.toFixed(2)} {currentOfferCurrency}
                    </div>
                    <p className={classNames(
                      css.offerDescription,
                      css.offerDescriptionAccordion,
                      { [css.offerDescriptionNoBorder]: offersData?.length === 1 }
                    )}
                    >
                      {o.message}
                    </p>
                  </div>
                )}
              </div>
            )
          })}
        </div>

        {feeFormatted && (
          <p className={css.offercommission}>
            <FormattedMessage id="BookingPanel.semotoCommission" values={{ fee: <b>{feeFormatted}</b> }} />
          </p>
        )}

        {!!additionalFeeFormatted && (
          <p className={css.offercommission}>
            <span className={css.tip}>
              <FormattedMessage id="BookingPanel.additionalFee" />
              <InfoTipForFields tipText={offerFeeData?.additionalFeeLabel} />
              -
            </span>
            <b>{additionalFeeFormatted}</b>
          </p>
        )}

        <UploadedFiles
          currentTransaction={currentTransaction}
          isProvider={isProvider}
        />
      </div>

      {isProvider ? (
        <p className={css.totalInfo}>
          <FormattedMessage id="BookingPanel.youllMake" values={{ total: <b>{totalPriceFormatted}</b> }} />
        </p>
      ) : (
        <p className={css.totalInfo}>
          <FormattedMessage id="BookingPanel.total" values={{ total: <b>{totalPriceFormatted}</b> }} />
        </p>
      )}

    </>
  );
};


AccordionOffers.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

AccordionOffers.propTypes = {
  rootClassName: string,
  className: string,
};

export default AccordionOffers;
